module.exports = __webpack_public_path__ + "src/img/play.f753149d.svg";